interface BankTransferDetails {
  label: string
  content: string | string[]
}

const bankTransferDetails: BankTransferDetails[] = [
  {
    label: 'Numer konta',
    content: '21 1750 0012 0000 0000 2060 1264'
  },
  {
    label: 'Odbiorca',
    content: ['Stowarzyszenie WIOSNA', 'ul. Wielicka 20,', '30-552 Kraków']
  },
  {
    label: 'Tytułem',
    content: 'Indeks sukcesów'
  },
  {
    label: 'Kwota',
    content: '{amount}'
  }
]

const foreignBankTransferDetails: BankTransferDetails[] = [
  {
    label: 'Kod SWIFT/BIC',
    content: 'PPABPLPKXXX'
  },
  {
    label: 'Nasz bank to',
    content: ['BNP Paribas Bank Polska S.A.', 'ul. Kasprzaka 10/16,', ' 01-211 Warszawa']
  },
  {
    label: 'Numer IBAN',
    content: 'PL 21 1750 0012 0000 0000 2060 1264'
  }
]

export { bankTransferDetails, foreignBankTransferDetails }
